import React from "react";
import SectionHeading from "../../SectionHeading";
import Spacing from "../../Spacing";
import ModalImage from "react-modal-image";

export default function AwardSectionStyle2({
  sectionTitle,
  sectionTitleUp,
  sectionSubTitle,
  data,
}) {
  return (
    <div className="container relative">
      {/* Section heading */}
      <SectionHeading
        title={sectionTitle}
        titleUp={sectionTitleUp}
        subTitle={sectionSubTitle}
        center
      />
      <Spacing md="72" lg="50" />

      {/* Certificate grid */}
      <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-8">
        {data?.map((item, index) => (
          <div key={index} className="w-full flex flex-col items-center justify-center">
            <div className="block cursor-pointer">
              <ModalImage
                small={item.iconUrl}
                large={item.iconUrl}
                alt={item.title}
                className="w-[550px] h-auto rounded-xl shadow-md transition-transform duration-300 hover:scale-105"
              />
            </div>

            {/* Title */}
            <h3 className="text-center mt-4 text-lg font-semibold text-gray-800">
              {item.title}
            </h3>
          </div>
        ))}
      </div>
    </div>
  );
}
